import angular from 'angular';

import EmailVerificationRequestModule from './email-verification-request';
import EmailVerificationConfirmModule from './email-verification-confirm';
import EmailVerificationRedirectModule from './email-verification-redirect';

export default angular
    .module('application.scene.identity.scene.email-verification.scene', [
        EmailVerificationRequestModule.name,
        EmailVerificationConfirmModule.name,
        EmailVerificationRedirectModule.name
    ]);



// WEBPACK FOOTER //
// ./src/application/scene/identity/scene/email-verification/scene/index.js